var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"text-16 mb-1"},[_vm._v("-")]),_vm._v(" "),_c('p',{staticClass:"text-16 mb-3"},[_vm._v("-")]),_vm._v(" "),_c('div',{staticClass:"mb-3"},_vm._l((_vm.order.products),function(product){return _c('product-item',{key:product.id,attrs:{"product":product}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }